export const isSafari = () => {
  return (
    window && /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)
  )
}

export const isChrome = () => {
  return window && window.navigator.userAgent.indexOf('Chrome') > -1
}

export const isFirefox = () => {
  return window && window.navigator.userAgent.indexOf('Firefox') > -1
}
